import React, { useState } from 'react';
import './Navbar.css';
import { FaInstagram, FaTiktok, FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom'; // Link ve useNavigate eklendi
import tesbihLogo from '../../assets/logo22.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const navigate = useNavigate();

  const handleMobileClick = (path) => {
    setIsOpen(false);
    setIsCategoryOpen(false);
    navigate(path);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Logo - Ana sayfaya yönlendirir */}
        <Link to="/" className="nav-logo" onClick={() => setIsOpen(false)}>
          <img src={tesbihLogo} alt="Tesbihçimen Logo" />
        </Link>

        {/* Hamburger Menu Icon (Mobile Only) */}
        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Navigation Content */}
        <div className={`nav-content ${isOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li>
              <Link to="/" onClick={() => setIsOpen(false)}>Anasayfa</Link>
            </li>
            
            <li className={`dropdown ${isCategoryOpen ? 'open' : ''}`}>
              <Link 
                to="/kategoriler" 
                className="dropdown-trigger" 
                onClick={(e) => {
                  if(window.innerWidth <= 992) {
                    e.preventDefault();
                    setIsCategoryOpen(!isCategoryOpen);
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                Kategoriler <FaChevronDown className={`arrow ${isCategoryOpen ? 'rotate' : ''}`} />
              </Link>
              
              <ul className="dropdown-menu">
                <li><Link to="/kategori/ates-kehribar" onClick={() => handleMobileClick('/kategori/ates-kehribar')}>Ateş Kehribar</Link></li>
                <li><Link to="/kategori/damla-kehribar" onClick={() => handleMobileClick('/kategori/damla-kehribar')}>Damla Kehribar</Link></li>
                <li><Link to="/kategori/kesme-iscilik" onClick={() => handleMobileClick('/kategori/kesme-iscilik')}>Kesme İşçilik</Link></li>
                <li><Link to="/kategori/osmanl-skma" onClick={() => handleMobileClick('/kategori/osmanl-skma')}>Osmanlı Sıkma</Link></li>
              </ul>
            </li>
            
            <li>
              <Link to="/urunler" onClick={() => setIsOpen(false)}>Ürünler</Link>
            </li>
          </ul>

          <div className="nav-right">
            <div className="social-icons">
              <a href="https://www.tiktok.com/@tesbihcimen.collection?lang=tr-TR" target="_blank" rel="noreferrer"><FaTiktok /></a>
            </div>
            <button className="contact-btn" onClick={() => handleMobileClick('/iletisim')}>İletişime Geç</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;